import { Component, Input, OnInit } from '@angular/core';
import { Indication } from 'src/app/_model/indication';

@Component({
  selector: 'app-indecations',
  templateUrl: './indecations.component.html',
  styleUrls: ['./indecations.component.scss']
})
export class IndecationsComponent implements OnInit {

  @Input() indications: Indication[];
  constructor() { }

  ngOnInit(): void {
  }

}
